import type {RichTextEditorSelection as Selection} from '@shopify/online-store-ui';

import type {ShopASTNode} from './types';

export const EMPTY_TEXT_NODE = {text: ''};

export const EMPTY_PARAGRAPH_NODE = {
  type: 'text',
  children: [EMPTY_TEXT_NODE],
};

export const EMPTY_VALUE = [
  {
    children: [EMPTY_TEXT_NODE],
  },
];

export const EMPTY_SHOP_AST: ShopASTNode = {
  type: 'root',
  children: [
    {
      type: 'paragraph',
      children: [
        {
          type: 'text',
          value: '',
        },
      ],
    },
  ],
};

export const EMPTY_SELECTION: Selection = {
  anchor: {
    path: [0, 0, 0],
    offset: 0,
  },
  focus: {
    path: [0, 0, 0],
    offset: 0,
  },
};
